import { createSlice, PayloadAction, createAsyncThunk  } from '@reduxjs/toolkit'
import { getOrderedState } from '../../../../utils/redux/reduxUtils'
import { getUser, getUsers } from '../../../../utils/requestsUtils/functionsRequests/user/userFunctions'


export type ExtraDataUser = {
    //LastEvaluatedKey?: string,
    page: number,
    limit?: number,
    searchNameStr?: string
}

export type NSS_Information = {
    curp:                 string
    fecha_de_nacimiento:  string
    lugar_de_nacimiento:  string
    nombre:               string
    nss:                  string
}


export type ManageUserTransactionGim = { state: "FINISH" | "CANCELLED",  gimmerId: string }
export type ManageUserTransactionGimmer = { state: "FINISH" | "CANCELLED",  gimId: string }

export type ManageUser = {
    countryName:            string
    firstName:              string
    id:                     string
    isProfilePicVerified:   boolean
    isProfilePicUploaded:   boolean
    isIdUploaded:           boolean
    isIdVerified:           boolean
    lastName:               string
    mail:                   string
    roleId:                 string
    imgUrl:                 string
    gimScore:               number
    gimmerScore:            number
    jobs:                   string[]
    gimmerJobs:             any[]
    Tax_Information:        boolean
    nss_information?:       NSS_Information
    phoneNumber:            string
    register_activity?:     string 

    GimmerTransactions:     ManageUserTransactionGimmer[]
    GimTransactions:     ManageUserTransactionGim[]
    GimTransactionsFinished:          number
    GimTransactionsCancelled:         number
    GimTransactionsTotal:             number

    GimmerTransactionsFinished:       number
    GimmerTransactionsCancelled:      number
    GimmerTransactionsTotal:          number
}




export const GetUsersThunk = createAsyncThunk(
    'manageUsersData/GetUsersThunk',
    async ({ page, limit, searchNameStr }: ExtraDataUser) => {
      try { 

        const res = await getUsers({ page, columns: "id", limit: limit === -1 ? undefined : limit, type: "ManageUsers", searchNameStr })
        console.log("res.results", res.results)
        res.results = res.results.map((user: ManageUser) => {
            //addRemainingFieldsOffer(offer)
            const totalGimFinished = user.GimTransactions.filter((u) => u.state === "FINISH").length
            const totalGimmerFinished = user.GimmerTransactions.filter((u) => u.state === "FINISH").length
            return {
                ...user,
                GimTransactionsFinished: totalGimFinished,
                GimTransactionsCancelled: user.GimTransactions.length - totalGimFinished,
                GimTransactionsTotal: user.GimTransactions.length,

                GimmerTransactionsFinished: totalGimmerFinished,
                GimmerTransactionsCancelled: user.GimmerTransactions.length - totalGimmerFinished,
                GimmerTransactionsTotal: user.GimmerTransactions.length,
            }
        })
        return {
          results: res.results as ManageUser[],
          page,
          limit,
          total: res.total
        }
      } catch (error) {
        console.log("error", error)
        return {
          results: [] as ManageUser[],
          page,
          limit,
          total: 0
        }
      }
    }
)


export const GetUserByIdThunk = createAsyncThunk(
  'manageUsersData/GetUserByIdThunk',
  async ({ id }: { id: string }) => {
    try { 
      const res = await getUser(id)
      return {
        user: res.user as ManageUser
      }
    } catch (error) {
      console.log("error", error)
      return {
        user: {} as ManageUser
      }
    }
  }
)

export const numberUsersByPage: number[] = [25, 50, 100, -1 ]

type InitialState = {
    total: number
    limit: number
    page: number
    usersToShow: ManageUser[]
    loadingContainer: boolean,
    orderDirection: boolean,
    orderColumn: string
    searchNameStr?: string
}

const initialState: InitialState = {
    total: 0,
    limit: numberUsersByPage[0],
    page: 1,
    usersToShow: [] as ManageUser[],
    //LastEvaluatedKey: "",
    loadingContainer: true,
    orderDirection: false,
    orderColumn: "",
}

export const manageUsersDataSlice = createSlice({
  name: 'manageUsersData',
  initialState,
  reducers: {

    removeDeletedUserReducer: (state, action: PayloadAction<{ id: string }>) => {
      const { id } = action.payload

      state.usersToShow = state.usersToShow.filter((user: ManageUser) => user.id !== action.payload.id)
      /*
      if(id === state.LastEvaluatedKey && state.usersIds.length > 1){
        const position = state.usersIds.indexOf(id)
        state.LastEvaluatedKey = state.usersIds[position-1]
      }*/
      state.total = state.total - 1
      return state
    },
    removeMultipleDeletedUserReducer: (state, action: PayloadAction<{ usersIds: string[] }>) => {
      const { usersIds } = action.payload

      state.usersToShow = state.usersToShow.filter((user: ManageUser) => !usersIds.includes(user.id) )
      /*
      if(usersIds.includes(state.LastEvaluatedKey) && state.usersIds.length > 1)
        state.LastEvaluatedKey = state.usersToShow[state.usersToShow.length - 1].id
      */
      state.total = state.total - usersIds.length
      return state
    },
    updateEditedUsersReducer: (state, action: PayloadAction<{ newUsersInfo: ManageUser[] }>) => {
        const { newUsersInfo } = action.payload
        state.usersToShow.forEach((user: ManageUser) => {
            const newUserInfo = newUsersInfo.find((userInfo: ManageUser) => user.id === userInfo.id)
            if(newUserInfo)
                return newUserInfo
            return user
        })
        return state
      },
    updateRoleUsersReducer: (state, action: PayloadAction<{userId: string, roleId: string}>) => {
      const { userId, roleId } = action.payload
      state.usersToShow.forEach((user: ManageUser) => {
          if(user.id === userId)
              user.roleId = roleId
      })
      return state
    },
    orderManageUsersReducer: (state, action: PayloadAction<{orderColumn: string, orderDirection: boolean}>) => {
        const { orderColumn, orderDirection  } = action.payload

        state.usersToShow = getOrderedState({ orderColumn, orderDirection, array: state.usersToShow })
        state.orderColumn = orderColumn
        state.orderDirection = orderDirection
        return state
    },
    resetManageUsersReducer: () => {
      return initialState
    }
  },

  extraReducers: (builder) => {
    builder.addCase(GetUsersThunk.fulfilled, (state, action: PayloadAction<{ results: ManageUser[],  page: number, limit?: number, total: number }>) => {
      const { results,  page, limit, total } = action.payload  

        state.usersToShow = results
        state.loadingContainer = false
        state.page = page
        state.limit = limit ?? -1
        state.total = total
        state.searchNameStr = ""
        return state
      }).addCase(GetUsersThunk.pending, (state, action: any) => {
        state.loadingContainer = true
        return state     
      }).addCase(GetUsersThunk.rejected, (state, action: any) => {
        const failState = {...initialState}
        failState.loadingContainer = false
        return failState
      })
      
      .addCase(GetUserByIdThunk.fulfilled, (state, action: PayloadAction<{ user: ManageUser }>) => {
        const { user } = action.payload
        if(user.id){
          state.usersToShow = new Array(user)
          state.total = 1
        }else{
          state.usersToShow = []
          state.total = 0
        }
        state.loadingContainer = false
        state.searchNameStr = ""
        return state
      }).addCase(GetUserByIdThunk.pending, (state, action: any) => {
          state.loadingContainer = true
          return state     
      }).addCase(GetUserByIdThunk.rejected, (state, action: any) => {
          const failState = {...initialState}
          failState.loadingContainer = false
          return failState
      })
  },

});

// Action creators are generated for each case reducer function
export const {  
    removeDeletedUserReducer,
    resetManageUsersReducer,
    removeMultipleDeletedUserReducer,
    orderManageUsersReducer,
    updateEditedUsersReducer,
    updateRoleUsersReducer
} = manageUsersDataSlice.actions

export default manageUsersDataSlice.reducer